import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Button } from 'components/Button/Button'
import { FlashingArrow } from 'components/FlashingArrow/FlashingArrow'

interface VerificationFooterProps {
    currentStep?: number
    previousStep?: () => void
    nextStep?: () => void
    nextDisabled?: boolean
    nextStepText?: string | null
}

export function VerificationFooter({
    currentStep,
    previousStep,
    nextStep,
    nextDisabled,
    nextStepText = null
}: VerificationFooterProps) {
    const { t } = useTranslation()

    const nextStepTextContent = nextStepText ?? t('next')

    return (
        <Container>
            <Button
                text='Prev'
                color='blue'
                width='14'
                height='5'
                font='mont-14-semi-bold'
                disabled={currentStep === 1}
                prevIcon={
                    <ArrowWrapper>
                        <FlashingArrow side='left' />
                    </ArrowWrapper>
                }
                clickFn={() => previousStep?.()}
            />
            <Button
                text={nextStepTextContent}
                color='blue'
                width='14'
                height='5'
                font='mont-14-semi-bold'
                disabled={nextDisabled}
                afterIcon={
                    <ArrowWrapper>
                        <FlashingArrow side='right' />
                    </ArrowWrapper>
                }
                clickFn={() => nextStep?.()}
            />
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 2rem;
`
const ArrowWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    & svg {
        display: block;
        vertical-align: middle;
    }
`